/**
 * Copyright (c) 2018-present, Luojun Jin
 *
 * @emails john.king.ca@gmail.com
 * @flow
 */

// $FlowExpectedError
import navDesign from '../../content/design/nav.yml';
// $FlowExpectedError
import navScripts from '../../content/scripts/nav.yml';

const sectionListDesign = navDesign.map(
  (item: Object): Object => ({
    ...item,
    directory: 'design',
  }),
);

export {
  sectionListDesign,
  navScripts as sectionListScripts,
};
